import React from 'react';
import { observer } from 'mobx-react';

import contactsStore from '../store/contactsStore';

import './AjaxActive.less';

const AjaxActive = observer(({ requestBusy }) => {
  if (!contactsStore.requestBusy) {
    return null;
  } else {
    return (
      <div>
        <i className="glyphicon glyphicon-refresh spinning" />
        Loading...
      </div>
    );
  }
});

export default AjaxActive;



// WEBPACK FOOTER //
// ./src/shared/AjaxActive.js